var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewXIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#595D5C",
  d: "M16.962 4.2h2.646l-5.781 6.608 6.801 8.992h-5.325l-4.171-5.454L6.359 19.8H3.71l6.184-7.068L3.37 4.2h5.46l3.771 4.985zm-.929 14.016H17.5L8.034 5.701H6.46z"
})));
export default SvgNewXIcon;